<comment>
訴求ポイント詳細
activeFeatureの内容を表示する
</comment>

<template>
  <div class="feature-detail" v-if="activeFeature">
    <div class="feature-detail__overlay" @click="displayFeature();"></div>
    <div class="feature-detail__content-wrap">
      <div class="feature-detail__content">
        <div class="feature-detail__visual-area">
          <img v-if="mainResourcePath && activeFeature.content_type==='img'" :src="mainResourcePath+'.jpg'" class="feature-detail__img" alt="">
          <video v-else-if="mainResourcePath && activeFeature.content_type==='movie'" :poster="mainResourcePath+'.jpg'" class="feature-detail__movie" controls autoplay>
            <source :src="mainResourcePath+'.mp4'">
            <p>動画を再生するには、videoタグをサポートしたブラウザが必要です。</p>
          </video>
        </div>
        <div class="feature-detail__text-area">
          <div class="feature-detail__title">{{activeFeature.label}}</div>
          <div class="feature-detail__description" v-html="activeFeature.description.split('\n').join('<br>')"></div>
        </div>
      </div>
      <button class="feature-detail__close-btn" @click="displayFeature();"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'featureDetail',
  computed: {
    ...mapGetters([
      'activeFeature'
    ]),
    mainResourcePath: function(){
      let path = null;
      if(this.activeFeature){
        path = '../../assets/materials/thumbnails/'+this.activeFeature.thumbnail[0];
      }
      return path;
    },
  },
  methods: {
    ...mapActions([
      'displayFeature'
    ]),
  },
}
</script>

<style lang="scss">
/* JSON内で直接タグが書かれるクラス */
.feature-detail__description{
  .fs-large{
    font-size: 110%;
  }
  .fs-notes{
    font-weight: normal;
    font-size: 95%;
    margin-top: -8px;
    font-family: "Meiryo UI";
  }
}
</style>

<style scoped lang="scss">
@mixin size_s_FD() {
  // 訴求ポイント詳細用1100ブレイク
  @media (max-width: 1100px){
    @content;
  }
}
.feature-detail{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &__overlay{
    z-index: 100;
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(100,100,100,0.5);
  }
  &__content-wrap{
    z-index: 110;
    position: absolute;
    top: 0;
    left: 50%;
    width: 1094px;
    height: 430px;
    margin: 40px 0 0 -547px;
    background: #FFF;
    @include size_s_FD(){
      width: 1000px;
      margin-left: -500px;
    }
  }
  &__content{
    display: flex;
    position: relative;
    height: 100%;
  }
  &__visual-area{
    width: 764px;
    min-width: 764px;
    max-width: 764px;
    display: flex;
    align-items: center;

    @include size_s_FD(){
      width: 670px;
      min-width: 670px;
      max-width: 670px;
    }
  }
  &__text-area{
    width: 270px;
    min-width: 270px;
    max-width: 270px;
    padding: 30px;
  }
  &__img{
    width: 100%;
    max-height: 100%;
  }
  &__movie{
    width: 100%;
    height: 100%;
  }
  &__title{
    font-size: 1.8rem;
  }
  &__description{
    font-size: 1.2rem;
    margin-top: 6px;
  }
  &__close-btn{
    appearance: none;
    border: none;
    background: url(../assets/image/fp_close_btn.png) no-repeat;
    background-size: auto;
    background-size: contain;
    bottom: 15px;
    height: 24px;
    position: absolute;
    right: 6px;
    width: 68px;
    cursor: pointer;
  }
}
</style>